import React from 'react';
import LogoImagee from '../assets/images/image_two.png';

const LogoImage = ({ width = "160", height = "80", className = "", alt = "Nikdip Logo" }) => {
  return (
    <img 
      src={LogoImagee} 
      alt={alt}
      width={width}
      height={height}
      className={className}
      style={{ 
        objectFit: 'contain',
        transition: 'transform 0.3s ease'
      }}
    />
  );
};

export default LogoImage;
